import React from 'react';
import { token } from '@atlaskit/tokens';
import { CustomThemeButton } from '@atlaskit/button';
import OpenIcon from '@atlaskit/icon/core/migration/arrow-up-right--open';
import ShortcutIcon from '@atlaskit/icon/core/migration/link-external--shortcut';
import { Anchor, Box, Flex, Grid, xcss } from '@atlaskit/primitives';

type ListItemProps = {
	title: string;
	icon?: React.ReactNode;
} & (ListItemLinkProps | ListItemButtonProps);

type ListItemLinkProps = {
	link: string;
	onClick: () => void;
};

type ListItemButtonProps = {
	onClick: () => void;
	link?: never;
};

type ListItemContentProps = {
	title: string;
	icon?: React.ReactNode;
	hasLink?: boolean;
};

const ListItemContent = ({ title, icon, hasLink }: ListItemContentProps) => (
	<Grid templateColumns="16px 1fr 16px" columnGap="space.200" alignItems="center">
		<Box>{icon}</Box>
		<Box>{title}</Box>
		<Box>
			{hasLink ? (
				<ShortcutIcon label="" LEGACY_size="small" />
			) : (
				<OpenIcon label="" LEGACY_size="small" />
			)}
		</Box>
	</Grid>
);

export const ListItem = ({ title, link, icon, onClick }: ListItemProps) => (
	<Flex as="li" xcss={listItemStyles} direction="column">
		{link ? (
			<Anchor href={link} target="_blank" xcss={linkStyles} onClick={onClick}>
				<ListItemContent title={title} icon={icon} hasLink />
			</Anchor>
		) : (
			<CustomThemeButton
				onClick={onClick}
				theme={(current, themeProps) => ({
					buttonStyles: {
						...current(themeProps).buttonStyles,
						padding: 0,
						height: 'auto',
						width: '100%',
						background: 'none',
						fontWeight: token('font.weight.regular'),
						textAlign: 'left',
						// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
						lineHeight: '18px',
					},
					spinnerStyles: current(themeProps).spinnerStyles,
				})}
			>
				<ListItemContent title={title} icon={icon} />
			</CustomThemeButton>
		)}
	</Flex>
);

const listItemStyles = xcss({
	marginTop: 'space.0',
	paddingBlock: 'space.100',
});

const linkStyles = xcss({
	color: 'color.text',
	fontWeight: token('font.weight.regular'),
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	lineHeight: '18px',
	textDecoration: 'none',

	':hover': {
		textDecoration: 'underline',
	},
});
